import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth';

const logoutCallbacks = ref<Map<string, () => Promise<unknown>>>(new Map());

export function useLogout() {
    const authStore = useAuthStore();

    function onBeforeLogout(callback: () => Promise<unknown>, key: string) {
        logoutCallbacks.value.set(key, callback);
    }

    function clearBeforeLogout(key: string) {
        logoutCallbacks.value.delete(key);
    }

    async function logout() {
        const promises = Array.from(logoutCallbacks.value.values()).map(
            (callback) => {
                return (async () => {
                    try {
                        return await callback();
                    } catch (error) {
                        console.error(error);
                        return null;
                    }
                })();
            }
        );

        await Promise.all(promises);

        authStore.logout();
    }

    return { clearBeforeLogout, logout, onBeforeLogout };
}
